/**
 * Toast helpers — thin branded wrapper around `react-hot-toast` so every
 * page calls `notify.success(...)` etc. and gets matching colors / icons.
 */
import React from 'react';
import baseToast, { Toaster as RHToaster, ToasterProps, ToastOptions } from 'react-hot-toast';
import { css } from './tokens';

const baseStyle: React.CSSProperties = {
  background: css.color.text,
  color: '#FFFFFF',
  borderRadius: 12,
  padding: '10px 14px',
  fontSize: 13,
  fontWeight: 600,
  boxShadow: css.shadow.lg,
};

export const Toaster: React.FC<Partial<ToasterProps>> = (props) => (
  <RHToaster
    position="top-center"
    reverseOrder={false}
    gutter={8}
    toastOptions={{
      duration: 3000,
      style: baseStyle,
      success: {
        duration: 2400,
        iconTheme: { primary: '#FFFFFF', secondary: '#16A34A' },
        style: { ...baseStyle, background: '#16A34A' },
      },
      error: {
        duration: 4000,
        iconTheme: { primary: '#FFFFFF', secondary: '#DC2626' },
        style: { ...baseStyle, background: '#DC2626' },
      },
      loading: {
        style: { ...baseStyle, background: css.color.text2 },
      },
    }}
    {...props}
  />
);

const notify = {
  success: (msg: string, opts?: ToastOptions) => baseToast.success(msg, opts),
  error:   (msg: string, opts?: ToastOptions) => baseToast.error(msg, opts),
  info:    (msg: string, opts?: ToastOptions) =>
    baseToast(msg, { ...opts, icon: opts?.icon ?? 'ℹ️', style: { ...baseStyle, background: css.color.info } }),
  loading: (msg: string, opts?: ToastOptions) => baseToast.loading(msg, opts),
  promise: <T,>(p: Promise<T>, msgs: { loading: string; success: string; error: string }) =>
    baseToast.promise(p, msgs),
  dismiss: (id?: string) => baseToast.dismiss(id),
};

export { notify };
export default notify;

